import React from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export const Swiperimg = (props) => {
  return (
    <div id="swiper">
      <div className="container">
        <div className="col-md-12 text-center">
          <img src="img/title-swiperimg.png" className="img-title" alt="" />
        </div>
        <div className="row text-center">
          <Swiper
            navigation={true}
            modules={[Navigation]}
            className="mySwiper swiper1"
            // style={{ border: '1px solid red' }} // 測試邊框
          >
            <SwiperSlide><img src="img/swiperimg/s1_01.jpg" className="" alt="" /></SwiperSlide>
            <SwiperSlide><img src="img/swiperimg/s1_02.jpg" className="" alt="" /></SwiperSlide>
            <SwiperSlide><img src="img/swiperimg/s1_03.jpg" className="" alt="" /></SwiperSlide>
            <SwiperSlide>Slide 4</SwiperSlide>
            <SwiperSlide>Slide 5</SwiperSlide>
            <SwiperSlide>Slide 6</SwiperSlide>
            <SwiperSlide>Slide 7</SwiperSlide>
            <SwiperSlide>Slide 8</SwiperSlide>
            <SwiperSlide>Slide 9</SwiperSlide>
          </Swiper>
          {/* 第二個滑動 */}
          <Swiper
            slidesPerView={2}
            spaceBetween={30}
            pagination={{
              clickable: true,
            }}
            navigation={true}
            modules={[Navigation]}
            className="mySwiper swiper2"
            // style={{ border: '1px solid yellow' }} // 測試邊框
          >
            <SwiperSlide><img src="img/swiperimg/s2_01.jpg" className="" alt="" /></SwiperSlide>
            <SwiperSlide><img src="img/swiperimg/s2_02.jpg" className="" alt="" /></SwiperSlide>
            <SwiperSlide><img src="img/swiperimg/s2_03.jpg" className="" alt="" /></SwiperSlide>
            <SwiperSlide>Slide 4</SwiperSlide>
            <SwiperSlide>Slide 5</SwiperSlide>
            <SwiperSlide>Slide 6</SwiperSlide>
            <SwiperSlide>Slide 7</SwiperSlide>
            <SwiperSlide>Slide 8</SwiperSlide>
            <SwiperSlide>Slide 9</SwiperSlide>
          </Swiper>
        </div>
      </div>
    </div>
  );
};
